import DeleteButton from "../../components/DeleteButton";
import EditButton from "../../components/EditButton";

import { numberToCurrency } from "../../helpers/functions";

const List = ({ data, onDelete, onEdit }) => {
  return (
    <div className="list-container">
      <div className="card d-none d-md-table w-100">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table  table-bordered border-light">
              <thead className="table-light">
                <tr>
                  <th className="border-end">#</th>
                  <th className="border-end">Spare Part</th>
                  <th className="border-end">Amount</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td className="border-end text-center text-nowrap">{index + 1}</td>
                    <td className="border-end">{item.name || ""}</td>
                    <td className="fw-bold border-end text-center text-nowrap">{numberToCurrency(item.amount)}</td>
                    <td>
                      <div className="d-flex gap-2 justify-content-center">
                        <EditButton onClick={() => onEdit(item)} />
                        <DeleteButton api={`parts?id=${item._id}`} onSuccess={onDelete} />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="d-md-none mb-4 w-100">
        {data.map((item, index) => (
          <div key={index} className="card shadow-sm mb-3">
            <div className="card-body">
              <div className="row g-2 mb-2">
                <div className="col-6">
                  <small className="text-muted">Spare Part</small>
                  <p className="mb-0 fw-medium">{item.name}</p>
                </div>
                <div className="col-6">
                  <small className="text-muted">Amount</small>
                  <p className="mb-0 fw-bold">{numberToCurrency(item.amount)}</p>
                </div>
              </div>

              <div className="d-flex justify-content-end gap-2 mt-2">
                <EditButton onClick={() => onEdit(item)} />
                <DeleteButton api={`parts?id=${item._id}`} onSuccess={onDelete} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default List;
